import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { api } from "../../services/api";
import styles from "./AvatarSelectionPage.module.scss";

import avatar1 from "../../assets/avatars/avatar_1.png";
import avatar2 from "../../assets/avatars/avatar_2.png";
import avatar3 from "../../assets/avatars/avatar_3.png";
import avatar4 from "../../assets/avatars/avatar_4.png";
import avatar5 from "../../assets/avatars/avatar_5.png";
import avatar6 from "../../assets/avatars/avatar_6.png";
import avatar7 from "../../assets/avatars/avatar_7.png";
import avatar8 from "../../assets/avatars/avatar_8.png";
import avatar9 from "../../assets/avatars/avatar_9.png";
import avatar10 from "../../assets/avatars/avatar_10.png";
import avatar11 from "../../assets/avatars/avatar_11.png";
import avatar12 from "../../assets/avatars/avatar_12.png";
import avatar13 from "../../assets/avatars/avatar_13.png";
import avatar14 from "../../assets/avatars/avatar_14.png";
import avatar15 from "../../assets/avatars/avatar_15.png";
import avatar16 from "../../assets/avatars/avatar_16.png";
import avatar17 from "../../assets/avatars/avatar_17.png";
import avatar18 from "../../assets/avatars/avatar_18.png";
import avatar19 from "../../assets/avatars/avatar_19.png";
import avatar20 from "../../assets/avatars/avatar_20.png";

const avatars = [
  avatar1, avatar2, avatar3, avatar4, avatar5,
  avatar6, avatar7, avatar8, avatar9, avatar10,
  avatar11, avatar12, avatar13, avatar14, avatar15,
  avatar16, avatar17, avatar18, avatar19, avatar20,
];

const AvatarSelectionPage: React.FC = () => {
  const navigate = useNavigate();
  const { user, setUser } = useUser();
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleAvatarClick = (index: number) => {
    if (loading) return;
    setSelectedIndex(index);
    setError(null);
  };

  const handleConfirm = async () => {
    if (selectedIndex === null || loading) return;

    setError(null);
    setLoading(true);

    const avatarId = `avatar_${selectedIndex + 1}`;

    try {
      const response = await api.app.selectAvatar(avatarId);
      if (user) {
        setUser({
          ...user,
          profileImageUrl: response.profileImageUrl,
        });
      }
      navigate("/");
    } catch (err: any) {
      const message =
        err?.message || "Failed to select avatar. Please try again.";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.avatarSelectionPage}>
      <h2 className={styles.title}>Choose your avatar</h2>
      {error && <p className={styles.error}>{error}</p>}
      <div className={styles.grid}>
        {avatars.map((avatar, index) => (
          <button
            key={avatar}
            className={`${styles.item} ${selectedIndex === index ? styles.selected : ""}`}
            type="button"
            disabled={loading}
            onClick={() => handleAvatarClick(index)}
            aria-label={`Select avatar ${index + 1}`}
          >
            <img
              src={avatar}
              alt={`Avatar ${index + 1}`}
              className={styles.image}
            />
          </button>
        ))}
      </div>
      <div className={styles.actions}>
        <button
          className={styles.confirmButton}
          type="button"
          disabled={selectedIndex === null || loading}
          onClick={handleConfirm}
        >
          {loading ? "Saving..." : "Select"}
        </button>
      </div>
    </div>
  );
};

export default AvatarSelectionPage;
